module.exports = "/assets/js/74e4e82b00d8465b43e3a4f47e6cc498.svg";